import fevaDisclosureViewTemplate from "./FevaDisclosureViewTemplate";

var FevaDisclosureDirective = function ($injector) {
    var logger = $injector.get("$log").getInstance("FevaDisclosureDirective");
    logger.debug("Directive loaded");

    return {
        restrict: "E",
        replace: "true",
        template: fevaDisclosureViewTemplate,
        scope: {
            isSubjectToFeva: "="
        }
    };
};

FevaDisclosureDirective.$inject = ["$injector"];
export default FevaDisclosureDirective;
